<template>
  <div class="burger-menu-nav" :class="{'burger-menu-nav_footer': isFooter}">
    <FooterNav v-if="isFooter" :nav-footer-list="navFooterList" :burger-list="burgerList"></FooterNav>
    <ul v-else class="burger-menu-nav__list">
      <li v-for="(item, index) in burgerList"
        :key="index"
        class="burger-menu-nav__item">
        <a v-if="item.link.includes('http')"
          :href="item.link"
          target="_blank"
          class="burger-menu-nav__go">
          {{ item.name }}
        </a>
        <router-link :to="item.link"
          class="burger-menu-nav__go"
          @click="$emit('link-clicked')"
          v-else>
          {{ item.name }}
        </router-link>
      </li>
    </ul>

    <template v-if="isFooter">
      <div v-if="linkYandex || linkGis" class="burger-menu-nav__item _rating">
        <a v-if="linkYandex" :href="linkYandex" target="_blank">
          <AppSvg id="yandex" width="82" height="48"></AppSvg>
        </a>
        <a v-if="linkGis" :href="linkGis" target="_blank">
          <AppSvg id="2gis" width="130" height="48"></AppSvg>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import FooterNav from './FooterNav.vue';
import AppSvg from './ui/AppSvg.vue';

export default {
  name: "BurgerMenuNav",

  components: {
    FooterNav,
    AppSvg,
  },

  props: {
    burgerList: {
      type: Array,
      default: () => [],
    },
    navFooterList: {
      type: Array,
      default: () => [],
    },
    isFooter: {
      type: Boolean,
      default: false,
    },
    linkYandex: {
      type: String,
      default: '',
    },
    linkGis: {
      type: String,
      default: '',
    },
  },

  emits: ["link-clicked"],
};
</script>

<style lang="scss" scoped>
.burger-menu-nav {
  $that: &;

  position: fixed;
  top: 100%;
  left: 0;
  transition: transform 0.35s 0.15s ease-out;
  transform: translate3d(-100%, 0, 0);
  z-index: 99;
  background-color: $color_dark-90;
  border-bottom-right-radius: 90px;

  @include phone {
    border-bottom-right-radius: 70px;
  }

  &_footer {
    position: absolute;
    width: 100%;
    max-height: 500px;
    top: 80px;
    overflow-y: auto;
    padding: 30px;

    @include phone {
      top: 66px;
      padding: 20px 30px;
    }
  }

  &._is-open {
    transform: translate3d(0, 0, 0);
  }

  ._secondary & {
    top: 89px;

    @include phone {
      top: 66px;
    }
  }

  &__list {
    min-width: 416px;
    //height: 242px;
    padding: 38px 56px;

    @include tablet {
      max-width: 416px;
      min-width: 100%;
      // width: 100%;
      height: auto;
      padding: 36px 32px;
    }
  }

  &__item {
    &+& {
      margin-top: 16px;
    }

    &._rating {
      display: flex;
      gap: 8px;
      margin-top: 20px;
    }
  }

  &__go {
    color: $white;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    transition: text-shadow 0.6s 0.1s cubic-bezier(0.22, 0.61, 0.36, 1);

    &:hover {
      text-shadow: 0 0 10px rgba(255, 255, 255, 1), 0 0 50px rgba(255, 255, 255, 0.8), 0 0 35px rgba(255, 255, 255, 0.6),
        0 0 76px rgba(255, 255, 255, 0.4), 0 0 37px rgba(255, 255, 255, 0.5), 0 0 78px rgba(255, 255, 255, 0.4),
        0 0 39px rgba(255, 255, 255, 0.3), 0 0 80px rgba(255, 255, 255, 0.2), 0 0 35px rgba(255, 255, 255, 0.1);
    }

    &.router-link-active {
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-decoration-color: $color_primary;
      text-underline-offset: 8px;
    }
  }
}
</style>
